<template>
  <v-container
    fill-height
    fluid
    style="padding: 0; margin: 0;"
    grid-list-xl>

    <v-layout
      justify-center
      wrap
    >
      <v-flex
        xs12
        md12
      >
        <material-card
          color="green"
        >
          <h2>{{ strings[idioma].criar_usuario }}</h2>
          <form autocomplete="off">
            <v-container py-0>
              <v-layout wrap>
                <v-flex
                  xs12
                  md6
                >
                  <v-text-field
                    v-model="user_.NOME"
                    :label="strings[idioma].nome"
                    :browser-autocomplete="rand()"
                    class="purple-input"
                  />
                </v-flex>
                <v-flex
                  xs12
                  md6
                >
                  <v-text-field
                    v-model="user_.email"
                    :label="strings[idioma].email"
                    :browser-autocomplete="rand()"
                    class="purple-input"
                    @change="(user_.email !== user.email) ? verificaEmail() : null"/>
                </v-flex>
                <v-flex
                  xs12
                  md6
                >
                  <v-text-field
                    v-model="user_.cpf"
                    :rules="cpfRules"
                    :browser-autocomplete="rand()"
                    label="CPF"
                    class="purple-input"
                    return-value
                    mask="###.###.###-##"
                    @keypress.native="val => $validateOnlyNumbers(val)"
                    @change.native="val => !$testaCPF(user_.cpf) ? user_.cpf = '' : null"/>
                </v-flex>
                <v-flex
                  xs12
                  md6
                >
                  <v-text-field
                    v-model="user_.password"
                    :label="strings[idioma].placeholder_senha"
                    :browser-autocomplete="'off'"
                    type="password"
                    readonly
                    onfocus="this.removeAttribute('readonly');"
                    class="purple-input"/>
                </v-flex>
                <v-flex
                  xs12
                  md4
                >
                  <v-text-field
                    v-model="user_.data_nascimento"
                    :browser-autocomplete="rand()"
                    label="Data de Nascimento*"
                    class="purple-input"
                    return-value

                    type="date"
                    @keypress.native="val => $validateOnlyNumbers(val)"/>
                </v-flex>
                <v-flex
                  xs12
                  md2
                >
                  <v-select
                    v-model="user_.sexo"
                    :browser-autocomplete="rand()"
                    :items="Sexo"
                    :item-text="'text'"
                    :item-value="'codigo'"
                    label="Sexo*"
                    class="purple-input"
                    return-value/>
                </v-flex>
                <v-flex
                  xs12
                  md6
                  style="border: 1px solid #000"
                >
                  <v-select
                    v-model="user_.perfil"
                    :browser-autocomplete="rand()"
                    :items="Perfis"
                    :item-text="'text'"
                    :item-value="'codigo'"
                    label="Perfil*"
                    class="purple-input"
                    return-value/>
                  <v-text-field
                    v-if="['outro'].includes(user_.perfil)"
                    v-model="user_.perfil_outro"
                    :browser-autocomplete="rand()"
                    label="Qual o seu perfil?"
                    class="purple-input"
                    return-value/>
                </v-flex>
                <v-flex
                  xs12
                  md6
                  style="border: 1px solid #000"
                >

                  <v-select
                    v-model="user_.como_encontrou_brcorte"
                    :browser-autocomplete="rand()"
                    :items="ComoEncontrouBRCorte"
                    :item-text="'text'"
                    :item-value="'codigo'"
                    label="Como encontrou o BR-Corte?"
                    class="purple-input"
                    return-value/>
                  <v-text-field
                    v-if="['outros', 'instagram', 'amigo', 'facebook', 'instituicao_ensino', 'instituicao_pesquisa', 'influencer'].includes(user_.como_encontrou_brcorte)"
                    v-model="user_.como_encontrou_brcorte_outro"
                    :browser-autocomplete="rand()"
                    :items="ComoEncontrouBRCorte"
                    :item-text="'text'"
                    :item-value="'codigo'"
                    label="Diga mais como conheceu o BR-Corte"
                    class="purple-input"
                    return-value/>
                </v-flex>
                <v-flex
                  xs12
                  md6
                  style="border: 1px solid #000"
                >
                  <v-text-field
                    v-model="user_.whatsapp"
                    :browser-autocomplete="rand()"
                    label="Whatsapp"
                    class="purple-input"
                    return-value/>
                </v-flex>
                <v-flex
                  xs12
                  md6
                  style="border: 1px solid #000"
                >
                  <template v-if="idioma === 0">
                    <v-autocomplete
                      v-model="user_.endereco.pais"
                      :label="strings[idioma].pais + '*'"
                      :items="Paises"
                      :item-text="'nome'"
                      :item-value="'nome'"
                      :browser-autocomplete="rand()"
                      no-data-text=""
                      class="purple-input"
                      @change="user_.telefone.cod_pais = parseInt(Paises.filter(p => p.nome === user_.endereco.pais)[0].fone)"
                    />
                  </template>
                  <template v-else>
                    <v-autocomplete
                      v-model="user_.endereco.pais"
                      :label="strings[idioma].pais + '*'"
                      :items="Paises"
                      :item-text="'nome_en'"
                      :item-value="'nome'"
                      :browser-autocomplete="rand()"
                      no-data-text=""
                      class="purple-input"
                      @change="user_.telefone.cod_pais = parseInt(Paises.filter(p => p.nome === user_.endereco.pais)[0].fone)"
                    />
                  </template>
                </v-flex>

                <v-flex
                  xs12
                  md2>
                  <v-text-field
                    v-model="user_.telefone.cod_pais"
                    :label="strings[idioma].cod_pais"
                    :browser-autocomplete="rand()"
                    type="number"
                    class="purple-input"
                    @keypress.native="val => $validateOnlyNumbers(val)"/>
                </v-flex>
                <v-flex
                  xs12
                  md2>
                  <v-text-field
                    v-if="user_.endereco.pais === 'Brasil'"
                    v-model="user_.telefone.DDD"
                    :label="strings[idioma].DDD"
                    :browser-autocomplete="rand()"
                    mask="##"
                    type="number"
                    class="purple-input"
                    @keypress.native="val => $validateOnlyNumbers(val)"/>
                  <v-text-field
                    v-else
                    v-model="user_.telefone.DDD"
                    :label="strings[idioma].DDD"
                    :browser-autocomplete="rand()"
                    type="number"
                    class="purple-input"
                    @keypress.native="val => $validateOnlyNumbers(val)"/>

                </v-flex>
                <v-flex
                  xs12
                  md8>
                  <v-text-field
                    v-model="user_.telefone.telefone"
                    :label="strings[idioma].telefone"
                    :browser-autocomplete="rand()"
                    type="number"
                    class="purple-input"
                    @keypress.native="val => $validateOnlyNumbers(val)"/>
                </v-flex>
                <v-flex
                  xs12
                  md2
                >
                  <v-text-field
                    v-model="user_.endereco.cep"
                    :label="strings[idioma].cep"
                    :browser-autocomplete="rand()"
                    return-value
                    mask="#####-###"
                    no-data-text=""
                    class="purple-input"/>
                </v-flex>
                <v-flex
                  xs12
                  md2
                >
                  <v-autocomplete
                    v-if="user_.endereco.pais === 'Brasil'"
                    v-model="user_.endereco.estado"
                    :label="strings[idioma].UF"
                    :items="UnidadesFederativas"
                    :item-text="'sigla'"
                    no-data-text=""
                    class="purple-input"
                  />
                  <v-text-field
                    v-else
                    v-model="user_.endereco.estado"
                    :label="strings[idioma].UF"
                    :browser-autocomplete="rand()"
                    class="purple-input"/>
                </v-flex>
                <v-flex
                  xs12
                  md5
                >
                  <v-autocomplete
                    v-if="user_.endereco.pais === 'Brasil'"
                    v-model="user_.endereco.cidade"
                    :label="strings[idioma].cidade"
                    :browser-autocomplete="rand()"
                    :items="Cidades"
                    no-data-text=""
                    class="purple-input"
                  />
                  <v-text-field
                    v-else
                    v-model="user_.endereco.cidade"
                    :label="strings[idioma].cidade"
                    :browser-autocomplete="rand()"
                    class="purple-input"/>

                </v-flex>
                <v-flex
                  xs12
                  md3
                >
                  <v-text-field
                    v-model="user_.endereco.bairro"
                    :label="strings[idioma].bairro"
                    :browser-autocomplete="rand()"
                    class="purple-input"/>

                </v-flex>
                <v-flex
                  xs12
                  md6
                >
                  <v-text-field
                    v-model="user_.endereco.logradouro"
                    :label="strings[idioma].logradouro"
                    :browser-autocomplete="rand()"
                    class="purple-input"/>
                </v-flex>
                <v-flex
                  xs12
                  md3
                >
                  <v-text-field
                    v-model="user_.endereco.numero"
                    :label="strings[idioma].numero"
                    :browser-autocomplete="rand()"
                    class="purple-input"/>
                </v-flex>
                <v-flex
                  xs12
                  md3
                >
                  <v-text-field
                    v-model="user_.endereco.complemento"
                    :label="strings[idioma].complemento"
                    :browser-autocomplete="rand()"
                    class="purple-input"/>
                </v-flex>
                <v-flex
                  xs12
                  md12
                >
                  <v-text-field
                    v-model="user_.endereco.referencia"
                    :label="strings[idioma].referencia"
                    :browser-autocomplete="rand()"
                    class="purple-input"/>
                </v-flex>
                <v-flex xs12>
                  <label>
                    {{ strings[idioma].usuario_permissao_sistema }}:
                  </label>
                  <v-radio-group
                    v-model="user_.permissao"
                    v-bind="binding"
                    row
                    class="purple-input"

                  >
                    <br>
                    <v-radio
                      :label="strings[idioma].usuario_permissao_adm"
                      :value="0"
                      color="primary"
                    />
                    <br>
                    <v-radio
                      :label="strings[idioma].usuario_permissao_comum"
                      :value="1"
                      color="primary"
                    />
                  </v-radio-group>
                </v-flex>
                <v-flex xs12>
                  <label>
                    {{ strings[idioma].usuario_com_premium }}
                  </label>
                  <v-radio-group
                    v-model="user_.premium"
                    v-bind="binding"
                    row
                    class="purple-input"

                  >
                    <br>
                    <v-radio
                      :label="strings[idioma].sim_premium"
                      :value="1"
                      color="primary"
                    />
                    <br>
                    <v-radio
                      :label="strings[idioma].nao_premium"
                      :value="0"
                      color="primary"
                    />
                  </v-radio-group>
                </v-flex>
                <v-flex xs12>
                  <label>
                    {{ strings[idioma].status_conta }}:
                  </label>
                  <v-radio-group
                    v-model="user_.EXCLUIDO"
                    v-bind="binding"
                    row
                    class="purple-input"

                  >
                    <br>
                    <v-radio
                      :label="strings[idioma].conta_ativa"
                      :value="0"
                      color="primary"
                    />
                    <br>
                    <v-radio
                      :label="strings[idioma].conta_inativa"
                      :value="1"
                      color="primary"
                    />
                  </v-radio-group>
                </v-flex>

                <v-flex xs12>
                  <v-layout
                    xs12
                    justify-space-between
                  >
                    <v-btn
                      class="mx-0 font-weight-light"
                      color="error"
                      @click="voltar()"
                    >
                      {{ strings[idioma].cancelar }}
                    </v-btn>
                    <v-btn
                      class="mx-0 font-weight-light"
                      color="success"
                      @click="update"
                    >
                      {{ strings[idioma].salvar }}
                    </v-btn>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-container>
          </form>
        </material-card>
      </v-flex>
    </v-layout>

  </v-container>
</template>

<script>
import { estados, paises } from '../../../lang/Strings'
import { mapState } from 'vuex'
import { EMPRESA_GESTOR, EMPRESA_GERENTE_REGIONAL, EMPRESA_TECNICO_VENDA, EMPRESA_PRODUTOR_VINCULADO, EMPRESA_TIPOS } from '../../../utils/types'
export default {
  data: () => ({
    user: {
      'id': 0,
      'NOME': '',
      'email': '',
      'phone': '',
      'permissao': 1,
      'EXCLUIDO': 0,
      'telefone': {
        'DDD': '',
        'cod_pais': '',
        'telefone': ''
      },
      'endereco': {
        'logradouro': '',
        'bairro': '',
        'cep': '',
        'estado': '',
        'cidade': '',
        'pais': '',
        'numero': '',
        'complemento': '',
        'referencia': ''
      }

    },
    user_: {
      'id': 0,
      'NOME': '',
      'email': '',
      'phone': '',
      'permissao': 1,
      'EXCLUIDO': 0,
      'telefone': {
        'DDD': '',
        'cod_pais': '',
        'telefone': ''
      },
      'endereco': {
        'logradouro': '',
        'bairro': '',
        'cep': '',
        'estado': '',
        'cidade': '',
        'pais': '',
        'numero': '',
        'complemento': '',
        'referencia': ''
      }

    },
    loading: false,
    EMPRESA_GESTOR: EMPRESA_GESTOR,
    EMPRESA_GERENTE_REGIONAL: EMPRESA_GERENTE_REGIONAL,
    EMPRESA_TECNICO_VENDA: EMPRESA_TECNICO_VENDA,
    EMPRESA_PRODUTOR_VINCULADO: EMPRESA_PRODUTOR_VINCULADO,
    EMPRESA_TIPOS: EMPRESA_TIPOS
  }),
  computed: {
    ...mapState('app', ['idioma', 'strings', 'empresa', 'acesso']),
    Perfis () {
      return [
        { 'codigo': 'consultor', 'text': 'Consultor' },
        { 'codigo': 'pecuarista', 'text': 'Pecuarista' },
        { 'codigo': 'professor', 'text': 'Professor' },
        { 'codigo': 'estudante', 'text': 'Estudante' },
        { 'codigo': 'outro', 'text': 'Outro' }
      ]
    },
    Sexo () {
      return [
        { 'codigo': 'M', 'text': 'Masculino' },
        { 'codigo': 'F', 'text': 'Feminino' },
        { 'codigo': 'N', 'text': 'Não quero identificar' }
      ]
    },
    ComoEncontrouBRCorte () {
      return [
        { 'codigo': 'google', 'text': 'Google' },
        { 'codigo': 'youtube', 'text': 'YouTube' },
        { 'codigo': 'instagram', 'text': 'Instagram' },
        { 'codigo': 'facebook', 'text': 'Facebook' },
        { 'codigo': 'linkedin', 'text': 'Linkedin' },
        { 'codigo': 'blog', 'text': 'Blog' },
        { 'codigo': 'livro', 'text': 'Livro' },
        { 'codigo': 'artigo_cientifico', 'text': 'Artigo' },
        { 'codigo': 'produtor', 'text': 'Produtor(a)' },
        { 'codigo': 'consultor', 'text': 'Consultor(a)' },
        { 'codigo': 'empresa', 'text': 'Empresa' },
        { 'codigo': 'amigo', 'text': 'Amigo' },
        { 'codigo': 'influencer', 'text': 'Influencer' },
        { 'codigo': 'instituicao_ensino', 'text': 'Instituicao de Ensino' },
        { 'codigo': 'instituicao_pesquisa', 'text': 'Instituicao de Pesquisa' },
        { 'codigo': 'outros', 'text': 'Outros' }
      ]
    },
    UnidadesFederativas () {
      return estados
    },
    Cidades () {
      let cidades = estados.filter(e => e.sigla === this.user_.endereco.estado)
      return cidades.length > 0 ? cidades[0].cidades : []
    },
    Paises () {
      return paises
    },
    heightCard () {
      return String(this.$vuetify.breakpoint.height - 289) + 'px'
    },
    heightDialog () {
      return this.$vuetify.breakpoint.xs ? String(this.$vuetify.breakpoint.height - 150) + 'px' : String(this.$vuetify.breakpoint.height - 240) + 'px'
    },
    heightUserOverflow () {
      return 'min-height: 225px; max-height: ' + String(this.$vuetify.breakpoint.height + 20) + 'px; overflow: auto;'
    },
    heightOverflow () {
      return 'max-height: ' + String(this.$vuetify.breakpoint.height - 50) + 'px; overflow-y: auto; overflow-x: hidden;'
    },
    heightTree () {
      return 'max-height: ' + String(this.$vuetify.breakpoint.height - 330) + 'px; overflow: auto; min-height: 200px;'
    }
  },
  created () {
    this.cpfRules = [
      value => {
        if (value !== null && String(value).trim() !== '' && !this.$testaCPF(value)) {
          return (value.length >= 11) ? this.strings[this.idioma].cpf_invalido : '.'
        } else if (value !== null && String(value).trim() !== '' && value.length >= 12) {
          return this.strings[this.idioma].cpf_minimo
        }
      }
    ]
    this.user = {
      'id': null,
      'NOME': '',
      'email': '',
      'phone': '',
      'permissao': 1,
      'EXCLUIDO': 0,
      'premium': 0,
      'telefone': {
        'DDD': '',
        'cod_pais': '',
        'telefone': ''
      },
      'endereco': {
        'logradouro': '',
        'bairro': '',
        'cep': '',
        'estado': '',
        'cidade': '',
        'pais': 'Brasil',
        'numero': '',
        'complemento': '',
        'referencia': ''
      }

    }
    this.reset()
    this.axios.post('users/get', {}).then(r => { this.users = r.data.data.users }).catch(() => this.$router.push('/'))
  },
  methods: {
    voltar () {
      window.location.href = '/adm'
    },
    parseString (valor, idioma) {
      if ((idioma === 2 || idioma === 0) && valor && valor !== '-') {
        if (valor[valor.length - 3] === '.') return parseFloat(valor)
        return parseFloat(valor.replace(/[.]/g, '').replace(/[,]/g, '.'))
      } else if (valor && valor !== '-') {
        return parseFloat(valor.replace(/[,]/g, ''))
      }
      return 0
    },
    cpfValidator (val, input, tipo) {
      return this.$validateOnlyNumbers(val)
    },
    reset () {
      this.user_ = Object.assign({}, this.user)
    },
    update () {
      this.loading = true
      if (this.user_.password === undefined || this.user_.password.trim() === '') {
        this.loading = false
        let msg = this.strings[this.idioma].digite_senha
        let time = 6000
        this.$store.commit('openErrorAlert', { msg, time })
        return
      }
      if (this.user_.email === undefined || this.user_.email.trim() === '') {
        this.loading = false
        let msg = this.strings[this.idioma].digite_email
        let time = 6000
        this.$store.commit('openErrorAlert', { msg, time })
        return
      }
      if (!this.$validateEmail(this.user_.email)) {
        this.loading = false
        let msg = this.strings[this.idioma].digite_email_valido
        let time = 6000
        this.$store.commit('openErrorAlert', { msg, time })
        return
      }

      this.verificaEmail(null, (email) => {
        this.axios.post('cadastraPessoaFisica', { email: email.trim(), NOME: this.user_.NOME.trim(), telefone: this.user_.telefone, endereco: this.user_.endereco, cpf: this.user_.cpf, EXCLUIDO: this.user_.EXCLUIDO, permissao: this.user_.permissao, password: this.user_.password, premium: this.user_.premium, perfil: this.user_.perfil, perfil_outro: this.user_.perfil_outro, data_nascimento: this.user_.data_nascimento, whatsapp: this.user_.whatsapp, sexo: this.user_.sexo, como_encontrou_brcorte: this.user_.como_encontrou_brcorte, como_encontrou_brcorte_outro: this.user_.como_encontrou_brcorte_outro }).then(response => {
          this.user.NOME = this.user_.NOME
          this.user.email = email
          this.user.telefone = this.user_.telefone
          this.user.cpf = this.user_.cpf
          this.user.EXCLUIDO = this.user_.EXCLUIDO
          this.user.permissao = this.user.permissao
          this.user.endereco = this.user_.endereco
          this.user.premium = this.user_.premium
          let msg = this.strings[this.idioma].cadastrado
          let title = ''
          this.$store.commit('openOKModal', { title, msg })
          this.loading = false
          this.voltar()
        }).catch(_ => {
          this.loading = false
          let msg = this.strings[this.idioma].erro_cadastro_usuario
          let time = 6000
          this.$store.commit('openErrorAlert', { msg, time })
        })
      }).catch(_ => {
        this.loading = false
        let msg = this.strings[this.idioma].email_ja_existe
        let time = 6000
        this.$store.commit('openErrorAlert', { msg, time })
      })
    },
    mudarSenha () {
      this.loading = true
      this.axios.post('/auth/esqueciSenha', { email: this.user.email }).then(response => {
        this.loading = false
        let msg = this.strings[this.idioma].enviado
        let title = this.strings[this.idioma].mudanca_senha
        this.$store.commit('openOKModal', { title, msg })
      }).catch(reason => {
        this.loading = false
        let msg = this.strings[this.idioma].usuario_nao_encontrado
        let time = 6000
        this.$store.commit('openErrorAlert', { msg, time })
      })
    },
    verificaEmail (fn = null, fncatch = null) {
      if (this.user_.email.trim() === this.user.email.trim()) {
        fncatch(this.user.email)
        return
      }
      if (!this.$validateEmail(this.user_.email)) {
        this.loading = false
        let msg = this.strings[this.idioma].digite_email_valido
        let time = 6000
        this.$store.commit('openErrorAlert', { msg, time })
        fncatch(this.user.email)
        return
      }
      this.axios.post('/auth/verificaEmail', { email: this.user_.email }).then(() => {
        this.user_.email = this.user.email
        let msg = this.strings[this.idioma].email_ja_existe
        let time = 6000
        this.$store.commit('openErrorAlert', { msg, time })
        if (fn !== null) {
          fn(this.user_.email)
        }
      }).catch(() => {
        if (fncatch !== null) {
          fncatch(this.user_.email)
        }
      })
    }
  }
}
</script>
